module.exports = __webpack_public_path__ + "img/landing_icon_4.b6ca122e.svg";